<template>
  <div>
    <div class="pa-2 layout-row layout-align-start-center">
      <div class="px-2">
        <lx-btn
          :dark="compColor.isInDarkMode"
          :label="$t('AUTH.EDIT_PASSWORD.BUTTONS.OPEN_COMPONENT')"
          :color="compColor.primeColor"
          :width="'auto'"
          classes="mt-0 text-none"
          @click="modal = true"
        ></lx-btn>
      </div>

    </div>
    <ValidationObserver ref="observer" v-slot="{ valid, pristine }" class="layout-column flex">
      <v-dialog
        v-model="modal"
        scrollable
        persistent
        :max-width="'1200px'"
        width="90%"
        min-height="90%"
        overlay-opacity="0.95"
        :dark="compColor.isInDarkMode"
        :color="compColor.primeColor"
      >
        <v-card>
          <v-card-title class="pa-0">
            <div class="pa-1 flex layout-row layout-align-start-center"
                 :class="[compColor.widget.headline]"
                 :style="{background: compColor.contentFrame}"
                 style="z-index: 2;border-radius:4px 4px 0 0;">
              <div class="layout-column layout-align-center-center pr-3">
                <v-avatar :color="compColor.avatarTile"
                          tile
                          height="40"
                          width="40"
                          style="min-width:40px;">
                  <v-icon :color="compColor.primeColor">mdi-fingerprint</v-icon>
                </v-avatar>
              </div>
              <span>{{ $t('AUTH.EDIT_PASSWORD.TITLE') }}</span>
            </div>
          </v-card-title>
          <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>
          <v-card-text style="height: 90%;" class="pa-1" :style="{background: compColor.contentFrame}">

            <div class="elevation-2" :style="{background: compColor.lxExpansion.background }" style="border-radius: 4px;">

              <div class="pa-0 pt-6 layout-column">
                <div class="flex-gt-sm-33 flex-100 px-4">
                  <validation-provider tag="div" ref="passwordOld" name="passwordOld"
                                       rules="min:1|requireDependency:passwordNew1"
                                       v-slot="{ errors }">
                    <v-text-field
                      :dark="compColor.isInDarkMode"
                      :append-icon="showPasswordsOld ? 'visibility_off' : 'visibility'"
                      clearable
                      @click:append="showPasswordsOld = !showPasswordsOld"
                      :color="compColor.primeColor"
                      :dense="denseFields"
                      :label="$t('AUTH.EDIT_PASSWORD.PASSWORD_CURRENT')"
                      outlined
                      prepend-inner-icon="fingerprint"
                      :error-messages="errors[0]"
                      :type="showPasswordsOld ? 'text' : 'password'"
                      v-model="model.oldPassword"
                    ></v-text-field>
                  </validation-provider>
                </div>

                <v-divider class="mb-6"></v-divider>

                <div class="flex-gt-sm-33 flex-100 px-4">
                  <validation-provider tag="div" ref="passwordNew1" name="passwordNew1"
                                       rules="min:1|requireDependency:passwordOld|password:passwordNew2"
                                       v-slot="{ errors }">
                    <v-text-field
                      :dark="compColor.isInDarkMode"
                      :append-icon="showPasswordsNew1 ? 'visibility_off' : 'visibility'"
                      clearable
                      @click:append="showPasswordsNew1 = !showPasswordsNew1"
                      :color="compColor.primeColor"
                      :dense="denseFields"
                      :label="$t('AUTH.EDIT_PASSWORD.PASSWORD_1')"
                      outlined
                      prepend-inner-icon="fingerprint"
                      :error-messages="errors[0]"
                      :type="showPasswordsNew1 ? 'text' : 'password'"
                      v-model="model.password"
                    ></v-text-field>
                  </validation-provider>
                </div>

                <div class="flex-gt-sm-33 flex-100 px-4">
                  <validation-provider tag="div" ref="passwordNew2" name="passwordNew2"
                                       rules="min:1|password:passwordNew1"
                                       v-slot="{ errors }">
                    <v-text-field
                      :dark="compColor.isInDarkMode"
                      :append-icon="showPasswordsNew2 ? 'visibility_off' : 'visibility'"
                      clearable
                      @click:append="showPasswordsNew2 = !showPasswordsNew2"
                      :color="compColor.primeColor"
                      :dense="denseFields"
                      :label="$t('AUTH.EDIT_PASSWORD.PASSWORD_2')"
                      outlined
                      prepend-inner-icon="fingerprint"
                      :type="showPasswordsNew2 ? 'text' : 'password'"
                      :error-messages="errors[0]"
                      v-model="model.newPassword"
                    ></v-text-field>
                  </validation-provider>
                </div>
              </div>
            </div>
          </v-card-text>

          <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

          <v-card-actions class="pa-1" :style="{background: compColor.contentFrame}">
            <v-spacer></v-spacer>
            <lx-btn :color="compColor.nav.contentFrame"
                    :icon-color="isDarkMode || isMediumMode ? compColor.primeHighlightColor : compColor.primeColor"
                    small
                    iconSize="20"
                    width="auto"
                    classes="text-none mr-1"
                    @click="changePassword"
                    icon="mdi-check"
                    :disabled="!valid || pristine || isLoading"
                    :label="$t('AUTH.EDIT_PASSWORD.BUTTONS.SUBMIT')"></lx-btn>
            <lx-btn :color="compColor.nav.contentFrame"
                    :icon-color="isDarkMode || isMediumMode ? compColor.primeHighlightColor : compColor.primeColor"
                    small
                    iconSize="20"
                    width="auto"
                    classes="text-none"
                    @click="close"
                    icon="mdi-cancel"
                    :label="$t('AUTH.EDIT_PASSWORD.BUTTONS.CANCEL')"></lx-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </ValidationObserver>
  </div>

</template>

<script>

export default {
  name: 'PasswordEditComponent',
  data () {
    return {
      showPasswordsOld: false,
      showPasswordsNew1: false,
      showPasswordsNew2: false,
      modal: false,
      model: {},
      isLoading: false
    }
  },
  methods: {
    changePassword () {
      if (this.isLoading) return
      this.isLoading = true

      this.$http.patch('/auth/user/changePassword', this.model)
        .then(() => {
          this.close()
          this.NotifySystem(this.$t('AUTH.EDIT_PASSWORD.SUCCESS'))
        })
        .catch(() => {
          delete this.model.password
          delete this.model.newPassword

          this.NotifyError(this.$t('AUTH.EDIT_PASSWORD.ERROR'))
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    close () {
      this.modal = false
      this.model = {}
    }
  }
}
</script>
